"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Pill = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Pill"));
var _excluded = ["to", "children"];
var styles = {
  "pill": "PillLink__pill__37RRc",
  "pill-span": "PillLink__pill-span__29Ebp",
  "pillSpan": "PillLink__pill-span__29Ebp",
  "pill-tag": "PillLink__pill-tag__1wXm3",
  "pillTag": "PillLink__pill-tag__1wXm3"
}; 
require('./PillLink.css');
var PillLink = /*#__PURE__*/_react.default.memo(function (_ref) {
  var to = _ref.to,
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: styles.pill,
    to: to
  }, /*#__PURE__*/_react.default.createElement(_Pill.default, (0, _extends2.default)({}, props, {
    className: styles.pillTag
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.pillSpan
  }, children)));
});
var _default = exports.default = PillLink;
//# sourceMappingURL=PillLink.js.map